import React from 'react'

const AttachmentIcon = ({color}: {color?: string}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clipPath='url(#clip0_15920_1423)'>
        <path
          d='M4.29697 16.4946C3.37782 15.607 2.90727 14.5348 2.88533 13.2779C2.86339 12.021 3.29623 10.933 4.18385 10.0138L10.2621 3.71958C10.8989 3.06018 11.6788 2.72243 12.6018 2.70632C13.5248 2.69021 14.316 3.00053 14.9754 3.63731C15.6348 4.27408 15.9726 5.05397 15.9887 5.977C16.0048 6.90003 15.6945 7.69124 15.0577 8.35063L9.55833 14.0454C9.15311 14.465 8.66574 14.6798 8.09621 14.6897C7.52669 14.6997 7.03211 14.502 6.6125 14.0968C6.19288 13.6916 5.97811 13.2042 5.96817 12.6347C5.95822 12.0652 6.15586 11.5706 6.56108 11.151L12.0605 5.45622L12.9596 6.32455L7.46025 12.0193C7.29624 12.1892 7.2162 12.387 7.22014 12.6129C7.22409 12.8387 7.31098 13.0336 7.48082 13.1977C7.65067 13.3617 7.84851 13.4417 8.07436 13.4378C8.30021 13.4338 8.49514 13.3469 8.65915 13.1771L14.1585 7.48231C14.5638 7.06269 14.7614 6.56812 14.7514 5.9986C14.7415 5.42907 14.5267 4.9417 14.1071 4.53648C13.6875 4.13126 13.1929 3.93362 12.6234 3.94357C12.0539 3.95351 11.5665 4.16828 11.1613 4.5879L5.08302 10.8821C4.44625 11.5415 4.13592 12.3327 4.15204 13.2558C4.16815 14.1788 4.5059 14.9587 5.1653 15.5954C5.82469 16.2322 6.6159 16.5425 7.53893 16.5264C8.46195 16.5103 9.24185 16.1726 9.87862 15.5132L15.9569 9.21895L16.8561 10.0873L10.7778 16.3815C9.89018 17.3007 8.81793 17.7712 7.56104 17.7931C6.30415 17.8151 5.21613 17.3822 4.29697 16.4946Z'
          fill={color ?? '#666666'}
        />
      </g>
      <defs>
        <clipPath id='clip0_15920_1423'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AttachmentIcon
